import { useEffect, useRef } from "react";
export default function TickerTape() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!ref.current) return;
    const s = document.createElement("script");
    s.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    s.async = true;
    s.innerHTML = JSON.stringify({
      symbols: [
        { proName: "NASDAQ:AAPL", title: "Apple" },
        { proName: "NASDAQ:MSFT", title: "Microsoft" },
        { proName: "NASDAQ:TSLA", title: "Tesla" },
        { proName: "AMEX:SPY", title: "S&P 500" },
        { proName: "NASDAQ:QQQ", title: "QQQ" },
        { proName: "NYSE:VTI", title: "VTI" },
      ],
      showSymbolLogo: true,
      colorTheme: "dark",
      isTransparent: true,
      displayMode: "adaptive",
      locale: "en",
    });
    ref.current.appendChild(s);
    return () => ref.current?.replaceChildren();
  }, []);
  return <div className="tradingview-widget-container" ref={ref} />;
}

